import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';

import { AccountServicesModule } from '../../account-services.module';

import { SwaggerException } from '../../components/swagger-exception/swagger-exception.component';
import { GetProfilePictureOutput } from '../../components/get-profile-picture-output/get-profile-picture-output.component';
import { environment } from 'src/environments/environment';


@Injectable({
	providedIn: AccountServicesModule
})
export class UploadImageProxyService {

	protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

	constructor(private httpClient: HttpClient) { }

	getUploadProfilePictureUrl() {
		return `${environment.api.baseUrl}/Profile/UploadProfilePicture`;
	}

	getProfilePicture(): Observable<GetProfilePictureOutput> {
		let url = `${environment.api.fasttrackApi}/services/app/Profile/GetProfilePicture`;
		url = url.replace(/[?&]$/, '');

		const options_: any = {
			observe: 'response',
			responseType: 'blob',
			headers: new HttpHeaders({
				'Accept': 'application/json'
			})
		};

		return this.httpClient.get(url, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processGetProfilePicture(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processGetProfilePicture(<any>response_);
				} catch (e) {
					return <Observable<GetProfilePictureOutput>><any>_observableThrow(e);
				}
			} else {
				return <Observable<GetProfilePictureOutput>><any>_observableThrow(response_);
			}
		}));
	}

	protected processGetProfilePicture(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		const _headers: any = {};
		if (response.headers) {
			for (const key of response.headers.keys()) { _headers[key] = response.headers.get(key); }
		}
		if (status === 200) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result200: any = null;
				const resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result200 = resultData200 ? GetProfilePictureOutput.fromJS(resultData200) : new GetProfilePictureOutput();
				return _observableOf(result200);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException({ message: 'An unexpected server error occurred.', status, response: _responseText, headers: _headers });
			}));
		}
		return _observableOf<GetProfilePictureOutput>(<any>null);
	}
}

function throwException(
	{ message, status, response, headers, result }:
	{ message: string; status: number; response: string; headers: { [key: string]: any; }; result?: any; }
): Observable<any> {
	if (result !== null && result !== undefined) {
		return _observableThrow(result);
	} else {
		return _observableThrow(new SwaggerException(message, status, response, headers, null));
	}
}

function blobToText(blob: any): Observable<string> {
	return new Observable<string>((observer: any) => {
		if (!blob) {
			observer.next('');
			observer.complete();
		} else {
			const reader = new FileReader();
			reader.onload = event => {
				observer.next((<any>event.target).result);
				observer.complete();
			};
			reader.readAsText(blob);
		}
	});
}
